import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';
import * as constants from '../constants/constants';

export function ProtectedRoute({ children }) {
  const { isLoggedIn } = useContext(AuthContext);

  // Si el usuario no está autenticado, redirigirlo a la página de inicio
  if (!isLoggedIn) {
    return <Navigate to={constants.HOME} />;
  }

  // Permitir el acceso a la ruta si el usuario está autenticado
  return <>{children}</>;
}
